import api from './api';
import mapMoney from './mapMoney';
import {
    db,
    serverTimestamp,
} from '../config/firebase';

function getQuickQuote(props) {
    const {
        applicationId,
        applicationType,
        applicantsIncome,
        mortgageType,
        estaminatedPropertyValue,
        estaminatedPropertyMonthlyRent,
        requestedLoanAmount,
        requestedTimeSpan,
    } = props;
    const params = {
        applicationType,
        applicants: applicantsIncome.length,
        applicantsIncome: applicantsIncome.map(item => mapMoney(item)),
        mortgageType,
        property: {
            estaminatedPropertyValue: mapMoney(estaminatedPropertyValue),
            estaminatedPropertyMonthlyRent: mapMoney(estaminatedPropertyMonthlyRent),
        },
        requestedTimeSpan,
    };
    switch (mortgageType) {
    case 'remortgage_current_balance':
        params.remortgageAmount = mapMoney(requestedLoanAmount);
        break;
    case 'remortgage_and_borrow_more':
        params.additionalAmount = mapMoney(requestedLoanAmount);
        break;
    default:
        params.requestedLoanAmount = mapMoney(requestedLoanAmount);
    }
    return new Promise((resolve, reject) => {
        api({
            method: 'calculateQuickQuote',
            params,
        })
            .then((data) => {
                if (data.error) {
                    reject(data.error);
                } else {
                    const collection = db.collection('applications');
                    const state = {
                        lastUpdate: serverTimestamp(),
                        quickQuote: {
                            ...params,
                            products: data.result,
                        },
                        customer: props.customer.uid ? props.customer : {},
                        formStepper: {
                            activeStep: 1,
                        },
                    };
                    if (applicationId) {
                        collection
                            .doc(applicationId)
                            .update(state)
                            .then(() => {
                                resolve({
                                    applicationId,
                                    products: data.result,
                                });
                            })
                            .catch((error) => {
                                reject(error.message);
                            });
                    } else {
                        collection
                            .add(state)
                            .then((docRef) => {
                                const { id } = docRef;
                                localStorage.setItem('applicationId', id);
                                resolve({
                                    applicationId: id,
                                    products: data.result,
                                });
                            })
                            .catch((error) => {
                                reject(error);
                            });
                    }
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export default getQuickQuote;



// WEBPACK FOOTER //
// ./src/service/getQuickQuote.js